import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { getDiscountPercentage } from '../../../../../common/global/helpers';
import { config } from '../../../config';
import { PriceModel, TaxInformation } from '../../../models/Product';
import { resources } from '../../../resources/resources';

interface IPriceAndTaxRateProps {
  price: PriceModel;
  taxRate?: number;
  taxInformations?: TaxInformation;
  isPriceLoading: boolean;
  isRecurring: boolean;
  cashback?: number;
  hasPriceRange: boolean;
}

export default function PriceAndTaxRateInfo(props: IPriceAndTaxRateProps) {
  const { price, isPriceLoading, cashback } = props;

  const { t: translate } = useTranslation();

  const maxRangeValue = props.hasPriceRange ? price.priceRanges![1] : null;

  const mainPrice = price.discountedPrice ?? price.defaultPrice;
  const isPriceDiscounted =
    !props.hasPriceRange &&
    !_.isNil(price.discountedPrice) &&
    price.defaultPrice !== price.discountedPrice;

  const recurringSuffix = props.isRecurring
    ? `/${translate(resources.cart.summary.month)}`
    : '';

  const renderPriceContent = () => {
    if (props.hasPriceRange) {
      if (maxRangeValue === 0) {
        return translate(resources.cart.summary.enterAmount);
      }

      return (
        <>
          {`${translate(resources.cart.summary.upTo)} ${maxRangeValue}`}
          <span className="product-currency">{config.currency}</span>
          {recurringSuffix}
        </>
      );
    }

    if (isPriceLoading) {
      return <Skeleton width={80} />;
    }

    return (
      <>
        {mainPrice}
        <span className="product-currency">{config.currency}</span>
        {recurringSuffix}
      </>
    );
  };

  return (
    <div className="product-value">
      <div className="product-price-box">
        <div className="product-price-current">
          {isPriceDiscounted && (
            <span className="product-discount">
              {getDiscountPercentage(price.defaultPrice, price.discountedPrice)}
              %
            </span>
          )}
          {!!cashback && (
            <span className="product-cashback-discount">
              {cashback} {config.currency}
            </span>
          )}
          <div>{renderPriceContent()}</div>
        </div>
        {isPriceDiscounted && (
          <div className="product-price-catalog">
            {`${price.defaultPrice} ${config.currency}${recurringSuffix}`}
          </div>
        )}
      </div>
    </div>
  );
}
